import { createSlice } from "@reduxjs/toolkit";

const infoSlice = createSlice({
  name: "infoSlice",
  initialState: { toggle: false },
  reducers: {
    infoOpen: (state, action) => {
      state.toggle = action.payload.value;
    },
    close: (state, action) => {
      state.toggle = action.payload.value;
    }
  }
})

export const { close, infoOpen } = infoSlice.actions;
export default infoSlice.reducer;
